import { Injectable, Signal } from '@angular/core';
import { Store } from '@ngrx/store';
import { toSignal } from '@angular/core/rxjs-interop';
import * as SequenceMetadataActions from '../state/actions';
import * as sequenceMetadataSelectors from '../state/selectors/sequence-metadata.selectors';
import { SequenceMetadataState } from '../state/reducers/sequence-metadata.reducer';
import { ISequenceMetadata, ISequenceMetadataCreate } from '../models/SequenceMetadata';
import { IDjangoErrors } from '../../../shared/models/DjangoErrors';

@Injectable({
  providedIn: 'root',
})
export class SequenceMetadataFacade {
  selectedSequenceMetadata$;
  loading$;
  errors$;

  selectedSequenceMetadataSignal: Signal<ISequenceMetadata | null>;
  loadingSignal: Signal<boolean>;
  errorsSignal: Signal<IDjangoErrors | null>;

  constructor(private store: Store<SequenceMetadataState>) {
    this.selectedSequenceMetadata$ = this.store.select(sequenceMetadataSelectors.getSelectedSequenceMetadata);
    this.loading$ = this.store.select(sequenceMetadataSelectors.getSequenceMetadataLoading);
    this.errors$ = this.store.select(sequenceMetadataSelectors.getSequenceMetadataErrors);

    this.selectedSequenceMetadataSignal = toSignal(this.selectedSequenceMetadata$, {
      initialValue: null,
    });
    this.loadingSignal = toSignal(this.loading$, { initialValue: false });
    this.errorsSignal = toSignal(this.errors$, { initialValue: null });
  }

  public getSequenceMetadata(sequenceId: number) {
    this.store.dispatch(SequenceMetadataActions.SequenceMetadataUiActions.GetSequenceMetadata({ sequenceId }));
  }

  public createSequenceMetadata(
    metadata: ISequenceMetadataCreate,
    sequenceId: number,
    description?: string,
    sourceType?: number | null,
    gcsFilePath?: string
  ) {
    this.store.dispatch(
      SequenceMetadataActions.SequenceMetadataUiActions.CreateSequenceMetadata({
        metadata,
        sequenceId,
        description,
        sourceType,
        gcsFilePath,
      })
    );
  }

  public promoteToPrimary(
    metadata: ISequenceMetadataCreate,
    sequenceId: number,
    description?: string,
    sourceType?: number | null,
    gcsFilePath?: string
  ) {
    this.store.dispatch(
      SequenceMetadataActions.SequenceMetadataUiActions.PromoteToPrimary({
        metadata,
        sequenceId,
        description,
        sourceType,
        gcsFilePath,
      })
    );
  }
}
